export default __webpack_public_path__ + "static/media/gps.0d6b1ea9.png";